import type { DocMigration } from "../docMigration";

function renameOffsetToLateralOffset(table: any): void {
  if (!table || typeof table !== "object") {
    return;
  }

  for (const id in table) {
    const entity = table[id];
    if (!entity || typeof entity !== "object") {
      continue;
    }
    if (!("offset" in entity)) {
      continue;
    }

    entity.lateralOffset = entity.offset;
    delete entity.offset;
  }
}

const migration: DocMigration = {
  id: "20260810_floorlateraloffsetrename",
  description: "Renames the floor/floor system lateral offset field from `offset` to `lateralOffset`",
  apply(json: any) {
    renameOffsetToLateralOffset(json.floors);
    renameOffsetToLateralOffset(json.floorSystems);
    return json;
  },
};

export default migration;
